module.exports = __webpack_public_path__ + "assets/img/2.7f9681e0.png";